module.exports = __webpack_public_path__ + "img/envelope-32.fb3939ab.svg";